import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = true;
const state = {
    // enotifyPromo的會員類別memberType:
    // NON=非會員，SCV=查詢會員，ONLINE=交易會員
    user: null,
    isLogin: false,
    overYearOtp: {
        chooseWay: '', // 選擇的項目
        contact: ',', // 聯絡號碼或是email
    },
};

export const eNotify = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
